import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { valuesToHtmlString } from './helpers/iframeHelpers';

class Iframe extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {
    this.updateIframe();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.size === "big" && JSON.stringify(nextProps.env) !== JSON.stringify(this.props.env)) {
      this.updateIframe(nextProps);
    }
  }

  componentDidUpdate() {
    // console.log(this.props);
    // if (this.props.size !== "big") { this.updateIframe(); }
  }

  updateIframe = (newProps) => {
    const doc = ReactDOM.findDOMNode(this).contentDocument;
    doc.open();
    if (typeof newProps === "undefined") {
      doc.write(valuesToHtmlString(this.props.env));
    } else {
      doc.write(valuesToHtmlString(newProps.env));
    }
    doc.close();
  }
  componentWillUnmount() {
    // console.log('I WILL UNMOUNT!')
  }

  render() {
    const bigStyle = {
      border: "1px solid #4e6192",
      height: "500px",
      width: "1000px",
      textAlign: "center",
    }
    const hostStyle = {
      border: "0",
      height: "500px",
      width: "1000px",
    }
    return ( this.props.size === "big" ?
      <iframe style={bigStyle} id="iframe" className="bigIframe"/> :
      this.props.size === "host" ?
      <iframe style={hostStyle} id="iframe" className="bigIframe"/> :
      <iframe className="galleryIframe"/>
    )
  }
}

export default Iframe



// WEBPACK FOOTER //
// ./src/Iframe.js